export default defineNuxtPlugin((nuxtApp) => {
  // 在服务端不注册指令，避免SSR警告
  const noop = () => {}

  // 先注册空实现，SSR 不做任何事
  nuxtApp.vueApp.directive('fade-up', { mounted: noop })
  nuxtApp.vueApp.directive('fade-up-group', { mounted: noop })

  if (import.meta.env.SSR) return

  /** 单个元素的 fade-up 动效 */
  nuxtApp.vueApp.directive('fade-up', {
    mounted(el, binding) {
      el.classList.add('fade-up')
      const once = binding.modifiers.once || binding.value?.once
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add('active')
            if (once) io.unobserve(el)
          } else if (!once) {
            el.classList.remove('active')
          }
        })
      }, { threshold: 0.1 })
      io.observe(el)
    },
  })

  /** 一组子元素依次触发的 fade-up 动效 */
  // <div v-fade-up-group="{ delayStep: 0.2 }">
  //   <div>卡片 1</div>
  //   <div>卡片 2</div>
  //   <div>卡片 3</div>
  // </div>
  nuxtApp.vueApp.directive('fade-up-group', {
    mounted(container, binding) {
      const children = Array.from(container.children) as HTMLElement[]
      const delayStep = binding.value?.delayStep ?? 0.1 // 每个子元素延迟递增（秒）
      const once = binding.modifiers.once || binding.value?.once

      // 初始化样式
      children.forEach((el, i) => {
        el.classList.add('fade-up')
        el.style.setProperty('--delay', `${i * delayStep}s`)
      })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            children.forEach((el) => el.classList.add('active'))
            if (once) io.unobserve(container)
          } else if (!once) {
            children.forEach((el) => el.classList.remove('active'))
          }
        })
      }, { threshold: 0.1 })

      io.observe(container)
    },
  })
})
